import React from "react";
import S from "../styles";

/**
 * What goes into ONE physical unit of a product. Read-only on purpose —
 * links are made from the Hardware page, where you set a screw once for
 * every product that uses it instead of opening 242 products one at a time.
 *
 * Printed pieces are not here yet: they live in the print farm, and the
 * platform has no record of them. The list takes them the day it does.
 */
export default function PartsAndHardwareRow({ entries, colSpan }) {
  return (
    <tr style={{ background: "rgba(0,51,255,0.04)" }}>
      <td colSpan={colSpan} style={{ padding: "10px 14px 12px 36px", borderBottom: "2px solid #0A0A0F" }}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.2, color: "rgba(10,10,15,0.58)", marginBottom: 8 }}>
          What goes into one
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 22px" }}>
          {entries.map((e) => (
            <div key={`${e.kind}-${e.id}`} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#0A0A0F" }}>
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, color: "#0033FF" }}>x{e.qty}</span>
              <span>{e.name}</span>
              <span style={S.typeBadge}>{e.kind === "piece" ? "Piece" : "Hardware"}</span>
            </div>
          ))}
        </div>
        <div style={{ fontSize: 12, color: "rgba(10,10,15,0.45)", marginTop: 8 }}>
          Set these on the Hardware &amp; Supplies page. Printed pieces are not
          listed here — they live in Print Farm, on the product's card.
        </div>
      </td>
    </tr>
  );
}
